/**
 * MR Pickup Guard (Cart page) — Shopify Dawn
 *
 * Goal (safe on Shopify standard plans):
 * - DO NOT block the main "Proceed to checkout" button (customers must reach checkout to pick MR point)
 * - DO hide/disable express payment buttons (Shop Pay / PayPal, etc.) until a pickup point is selected
 * - Show a notice explaining that pickup selection happens at the next step (Shipping)
 *
 * This avoids the common issue: customers paying via express buttons without selecting a pickup point.
 *
 * You can remove this file + the script tag in theme.liquid to revert.
 */

(function () {
  // Run only on /cart
  const isCartPage =
    window.location.pathname === "/cart" ||
    document.body.classList.contains("template-cart");
  if (!isCartPage) return;

  // Dawn-ish selectors
  const SELECTORS = {
    // Main checkout button(s) — we will NOT disable these
    checkoutButtons: [
      'button[name="checkout"]',
      'form[action^="/cart"] button[type="submit"][name="checkout"]',
      ".cart__checkout-button",
      "#checkout",
      '[data-testid="checkout-button"]',
    ],

    // Express/dynamic checkout areas to hide until pickup chosen
    expressAreas: [
      ".dynamic-checkout__content",
      ".shopify-payment-button",
      ".shopify-payment-button__button",
      ".shopify-payment-button__more-options",
    ],

    // Where to inject the notice
    noticeAnchors: [".cart__footer", ".cart__blocks", "form[action^='/cart']"],
  };

  // Known-ish storage keys used by pickup apps (heuristic)
  const STORAGE_KEYS = [
    "mondialrelay_selected",
    "mondial_relay_selected",
    "mr_selected",
    "inpost_pickup",
    "inpost_selected",
    "pickup_point",
    "pickupPoint",
    "relay_point",
    "relayPoint",
    "selectedRelay",
    "selected_relay",
    "MR_selected_relay",
    "mondialrelay_pickup",
    "mondial_relay_pickup",
  ];

  function uniq(arr) {
    return [...new Set(arr)];
  }

  function qsaMany(selectors) {
    const els = [];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((e) => els.push(e));
    });
    return uniq(els);
  }

  function getSelectedFromStorage() {
    try {
      for (const k of STORAGE_KEYS) {
        const v = localStorage.getItem(k) || sessionStorage.getItem(k);
        if (v && v !== "null" && v !== "undefined" && v !== "{}") return v;
      }
    } catch (e) {}
    return null;
  }

  async function getCartAttributes() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return {};
      const cart = await res.json();
      return cart.attributes || {};
    } catch (e) {
      return {};
    }
  }

  function hasPickupInAttributes(attrs) {
    if (!attrs) return false;
    const entries = Object.entries(attrs);
    // If any cart attribute key looks like pickup data and value is non-empty
    return entries.some(([k, v]) => {
      const key = String(k || "").toLowerCase();
      const val = String(v || "").trim();
      if (!val) return false;
      return (
        key.includes("mondial") ||
        key.includes("relay") ||
        key.includes("relais") ||
        key.includes("inpost") ||
        key.includes("pickup") ||
        key.includes("locker") ||
        key.includes("point")
      );
    });
  }

  function ensureNotice() {
    let notice = document.querySelector("#mr-pickup-notice");
    if (notice) return notice;

    notice = document.createElement("div");
    notice.id = "mr-pickup-notice";
    notice.style.margin = "12px 0";
    notice.style.padding = "12px 14px";
    notice.style.border = "1px solid rgba(0,0,0,.15)";
    notice.style.borderRadius = "10px";
    notice.style.fontSize = "14px";
    notice.style.lineHeight = "1.4";
    notice.style.background = "rgba(255, 196, 0, 0.12)";
    notice.style.display = "none";
    notice.innerHTML =
      "<strong>Point relais à choisir.</strong> Vous pourrez sélectionner votre point Mondial Relay à l’étape suivante (Livraison) après avoir cliqué sur <em>Procéder au paiement</em>.";

    // find an anchor
    let anchor = null;
    for (const sel of SELECTORS.noticeAnchors) {
      anchor = document.querySelector(sel);
      if (anchor) break;
    }
    (anchor || document.body).prepend(notice);
    return notice;
  }

  function hideExpress(shouldHide) {
    const expressEls = qsaMany(SELECTORS.expressAreas);

    // If the container is hidden, buttons inside won't be clickable
    expressEls.forEach((el) => {
      if (shouldHide) {
        el.dataset.mrHidden = "1";
        el.style.display = "none";
      } else {
        if (el.dataset.mrHidden === "1") el.style.display = "";
      }
    });
  }

  async function refreshState() {
    const notice = ensureNotice();

    // Detect selection signal
    const selectedStorage = getSelectedFromStorage();
    const attrs = await getCartAttributes();
    const selectedAttrs = hasPickupInAttributes(attrs);
    const hasSelection = Boolean(selectedStorage) || Boolean(selectedAttrs);

    // ✅ Always allow main checkout button
    // (We don't disable it on Shopify standard because pickup selection is usually in checkout.)
    // But we DO block express payments to prevent bypass.
    if (!hasSelection) {
      hideExpress(true);
      notice.style.display = "block";
    } else {
      hideExpress(false);
      notice.style.display = "none";
    }
  }

  // Observe DOM changes (apps can inject dynamic checkout buttons after load)
  const observer = new MutationObserver(() => {
    refreshState();
  });

  document.addEventListener("DOMContentLoaded", () => {
    refreshState();
    observer.observe(document.body, { childList: true, subtree: true });
    // Poll for storage updates too
    setInterval(refreshState, 1200);
  });
})();
